"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapNotifyCapability = void 0;
// dummy capability, this capability reuses the IRCv3 CAP command with a new subcommand
exports.CapNotifyCapability = {
    name: 'cap-notify'
};
